import { render, staticRenderFns } from "./ChatAvatar.vue?vue&type=template&id=29dc3854&scoped=true&"
import script from "./ChatAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChatAvatar.vue?vue&type=style&index=0&id=29dc3854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc3854",
  null
  
)

export default component.exports